<template>
	<button @click="listGroups" type="button" class="sm-button sm-edit-button"><div class="dashicons-before" :class="icon"></div><slot></slot></button>
</template>

<script>
export default {
	props: ['group', 'icon'],
	methods: {
		listGroups: function() {
			this.$emit('groups', this.group);
		}
	}
};
</script>


// WEBPACK FOOTER //
// GroupButton.vue?6cf8b035